(() => {
  // Mobile menu
  const toggle = document.querySelector('[data-menu-toggle]');
  const drawer = document.querySelector('[data-mobile-nav]');
  if (toggle && drawer) {
    toggle.addEventListener('click', () => {
      const open = drawer.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
    });
  }

  // Quantity steppers
  document.querySelectorAll('[data-qty]').forEach((wrap) => {
    const input = wrap.querySelector('input');
    wrap.querySelectorAll('button').forEach((btn) => {
      btn.addEventListener('click', () => {
        const next = Math.max(1, (parseInt(input.value, 10) || 1) + parseInt(btn.dataset.step, 10));
        input.value = next;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });

  // Live collection filtering + sorting: a checkbox, price field or sort choice fetches just
  // the results and the facet list (Shopify's section-rendering endpoint) and swaps them in,
  // instead of a full page reload. Checkboxes and the sort select apply instantly; the price
  // fields debounce briefly so they don't fire on every keystroke.
  let results = document.querySelector('[data-collection-results]');
  if (results) {
    let drawerBody = document.querySelector('[data-filter-drawer-body]');
    const drawerForm = document.querySelector('[data-filter-form]');
    const drawerEl = document.querySelector('[data-filter-drawer]');
    let inFlight = null;
    let debounceTimer = null;

    // The section's rendering-endpoint id is the theme's actual runtime id (e.g.
    // "template--123__main"), not the "main" key from the JSON template, so read it
    // from the wrapper Shopify already put around the section.
    const sectionWrapper = results.closest('[id^="shopify-section-"]');
    const sectionId = sectionWrapper ? sectionWrapper.id.replace('shopify-section-', '') : 'main';

    const formUrl = (form) => {
      const params = new URLSearchParams(new FormData(form));
      return `${form.action}?${params.toString()}`;
    };

    const apply = (url, { push = true, scroll = false } = {}) => {
      clearTimeout(debounceTimer);
      if (inFlight) inFlight.abort();
      const ctrl = new AbortController();
      inFlight = ctrl;
      results.classList.add('is-loading');
      const sep = url.includes('?') ? '&' : '?';
      fetch(`${url}${sep}section_id=${encodeURIComponent(sectionId)}`, { signal: ctrl.signal })
        .then((r) => {
          if (!r.ok) throw new Error(`Section fetch failed: ${r.status}`);
          return r.text();
        })
        .then((html) => {
          const doc = new DOMParser().parseFromString(html, 'text/html');
          const newResults = doc.querySelector('[data-collection-results]');
          const newBody = doc.querySelector('[data-filter-drawer-body]');
          if (newResults) {
            results.replaceWith(newResults);
            results = newResults;
            wireResults();
            if (scroll) results.scrollIntoView({ block: 'start', behavior: 'smooth' });
          }
          if (newBody && drawerBody) {
            drawerBody.replaceWith(newBody);
            drawerBody = newBody;
            wireDrawerBody();
          }
          if (push) window.history.pushState({}, '', url);
        })
        .catch((err) => { if (err.name !== 'AbortError') window.location.href = url; })
        .finally(() => { if (inFlight === ctrl) results.classList.remove('is-loading'); });
    };

    function wireResults() {
      results.querySelectorAll('.pagination a').forEach((a) => {
        a.addEventListener('click', (e) => { e.preventDefault(); apply(a.href, { scroll: true }); });
      });
      results.querySelectorAll('.active-filters .chip, .clear-link').forEach((a) => {
        a.addEventListener('click', (e) => { e.preventDefault(); apply(a.href); });
      });
      const sortForm = results.querySelector('[data-sort-form]');
      if (sortForm) {
        sortForm.querySelector('[data-live-change]').addEventListener('change', () => apply(formUrl(sortForm)));
      }
    }

    function wireDrawerBody() {
      if (!drawerForm) return;
      drawerBody.querySelectorAll('[data-live-change]').forEach((el) => {
        const trigger = () => apply(formUrl(drawerForm));
        if (el.hasAttribute('data-live-debounce')) {
          el.addEventListener('input', () => {
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(trigger, 450);
          });
        } else {
          el.addEventListener('change', trigger);
        }
      });
    }

    wireResults();
    wireDrawerBody();

    if (drawerForm) {
      drawerForm.addEventListener('submit', (e) => {
        e.preventDefault();
        clearTimeout(debounceTimer);
        apply(formUrl(drawerForm));
        if (drawerEl) drawerEl.dispatchEvent(new Event('filter:apply'));
      });
      const clearAll = drawerForm.querySelector('[data-clear-all]');
      if (clearAll) clearAll.addEventListener('click', (e) => { e.preventDefault(); apply(clearAll.href); });
    }

    window.addEventListener('popstate', () => apply(location.href, { push: false }));
  }

  // Product page: variant picker + gallery
  const productRoot = document.querySelector('[data-product]');
  if (productRoot) {
    const variants = JSON.parse(productRoot.querySelector('[data-variants]').textContent);
    const idInput = productRoot.querySelector('[name=id]');
    const addBtn = productRoot.querySelector('[data-add-btn]');
    const priceEl = productRoot.querySelector('[data-price]');
    const fieldsets = [...productRoot.querySelectorAll('[data-option]')];
    const stickyBtn = productRoot.querySelector('[data-sticky-atc-btn]');
    const stickyLabel = stickyBtn?.querySelector('[data-sticky-atc-label]');
    const stickyPriceEl = productRoot.querySelector('[data-sticky-atc-price]');
    const stickySizeEl = productRoot.querySelector('[data-sticky-atc-size]');
    const sizeFieldset = fieldsets.find((f) => /maat|size|grootte/i.test(f.querySelector('legend')?.textContent || ''));

    const update = () => {
      const chosen = fieldsets.map((f) => f.querySelector('input:checked')?.value);
      const match = variants.find((v) => v.options.every((o, i) => o === chosen[i]));
      if (!match) {
        addBtn.disabled = true;
        addBtn.textContent = addBtn.dataset.unavailable;
        if (stickyBtn) { stickyBtn.disabled = true; if (stickyLabel) stickyLabel.textContent = addBtn.dataset.unavailable; }
        return;
      }
      idInput.value = match.id;
      addBtn.disabled = !match.available;
      addBtn.textContent = match.available ? addBtn.dataset.add : addBtn.dataset.soldout;
      if (priceEl) priceEl.innerHTML = match.price_html;
      if (stickyBtn) { stickyBtn.disabled = !match.available; if (stickyLabel) stickyLabel.textContent = addBtn.textContent; }
      if (stickyPriceEl) stickyPriceEl.innerHTML = match.price_html;
      if (stickySizeEl && sizeFieldset) stickySizeEl.textContent = sizeFieldset.querySelector('input:checked')?.value || '';
      if (match.image) showImage(match.image);
      const url = new URL(window.location);
      url.searchParams.set('variant', match.id);
      window.history.replaceState({}, '', url);
    };
    const markSoldOut = () => {
      const chosen = fieldsets.map((f) => f.querySelector('input:checked')?.value);
      fieldsets.forEach((f, i) => f.querySelectorAll('input').forEach((inp) => {
        const combo = chosen.slice();
        combo[i] = inp.value;
        const ok = variants.some((v) => v.available && v.options.every((o, j) => o === combo[j]));
        inp.nextElementSibling.classList.toggle('is-soldout', !ok);
      }));
      fieldsets.forEach((f) => {
        const label = f.querySelector('legend strong');
        const checked = f.querySelector('input:checked');
        if (label && checked) label.textContent = checked.value;
      });
    };
    const giftAmounts = [...productRoot.querySelectorAll('[data-gift-amount]')];
    const syncGiftAmount = () => { if (priceEl) giftAmounts.forEach((el) => { el.textContent = priceEl.textContent.trim(); }); };
    // "Complete the look": highlight the size chosen above on each recommended product (when that size exists there).
    // Clicking a chip picks that size instead of leaving the page; the card's own link then opens the product in that size.
    const norm = (t) => String(t || '').toLowerCase().replace(/[\s/\u2013\u2014]+/g, '-').trim();
    const cardLinks = (card) => [...card.querySelectorAll('.card__title a, a.card__media')];
    const pickChip = (chip) => {
      const card = chip.closest('.card');
      card.querySelectorAll('.card__sizes a').forEach((c) => { c.classList.toggle('is-selected', c === chip); c.setAttribute('aria-pressed', String(c === chip)); });
      cardLinks(card).forEach((a) => { if (!a.dataset.lookHref) a.dataset.lookHref = a.getAttribute('href'); a.href = chip.href; });
    };
    const clearChip = (card) => {
      card.querySelectorAll('.card__sizes a').forEach((c) => { c.classList.remove('is-selected'); c.removeAttribute('aria-pressed'); });
      cardLinks(card).forEach((a) => { if (a.dataset.lookHref) a.setAttribute('href', a.dataset.lookHref); });
    };
    const syncLook = () => {
      const size = fieldsets.find((f) => /maat|size|grootte/i.test(f.querySelector('legend')?.textContent || ''));
      const chosen = norm(size?.querySelector('input:checked')?.value);
      productRoot.querySelectorAll('.complete-look__panel .card').forEach((card) => {
        if (card.dataset.lookManual) return;
        const chip = [...card.querySelectorAll('.card__sizes a')].find((c) => chosen && norm(c.textContent) === chosen);
        if (chip) pickChip(chip); else clearChip(card);
      });
    };
    productRoot.addEventListener('click', (e) => {
      const chip = e.target.closest('.complete-look__panel .card__sizes a');
      if (!chip) return;
      e.preventDefault();
      chip.closest('.card').dataset.lookManual = '1';
      pickChip(chip);
    });
    productRoot.addEventListener('recommendations:loaded', syncLook);

    fieldsets.forEach((f) => f.addEventListener('change', () => { update(); markSoldOut(); syncGiftAmount(); syncLook(); }));

    // Gift card: optional recipient fields (only submitted when "send to someone else" is ticked)
    const gc = productRoot.querySelector('[data-gc-recipient]');
    if (gc) {
      const toggle = gc.querySelector('[data-gc-toggle]');
      const fields = gc.querySelector('[data-gc-fields]');
      const note = gc.querySelector('[data-gc-self-note]');
      const date = gc.querySelector('[data-gc-date]');
      const offset = gc.querySelector('[data-gc-offset]');
      const iso = (d) => new Date(d.getTime() - d.getTimezoneOffset() * 60000).toISOString().slice(0, 10);
      const now = new Date();
      date.min = iso(now);
      date.max = iso(new Date(now.getTime() + 90 * 864e5));
      const sync = () => {
        const on = toggle.checked;
        fields.hidden = !on;
        note.hidden = on;
        fields.querySelectorAll('input, textarea').forEach((el) => { el.disabled = !on; });
        offset.value = String(now.getTimezoneOffset());
        gc.querySelector('[name="properties[Recipient email]"]').required = on;
      };
      toggle.addEventListener('change', sync);
      sync();
    }
    markSoldOut();

    // Sticky "add to cart" bar (mobile): mirrors the real buy button and only shows
    // once that button has scrolled out of view, in either direction.
    const stickyBar = productRoot.querySelector('[data-sticky-atc]');
    const buyRow = productRoot.querySelector('.buy');
    if (stickyBar && buyRow) {
      if ('IntersectionObserver' in window) {
        const atcIO = new IntersectionObserver(([entry]) => {
          stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        }, { threshold: 0 });
        atcIO.observe(buyRow);
      }
      stickyBtn?.addEventListener('click', () => addBtn.click());
    }

    // Gallery slider: one photo at a time (swipe / arrows / thumbnails), endless in both directions.
    // A copy of the last photo sits before the first and a copy of the first after the last; once a swipe settles on
    // a copy we jump (unseen) to the real photo, so going past the end just keeps sliding.
    const track = productRoot.querySelector('[data-gallery-track]');
    const slides = track ? [...track.querySelectorAll('[data-gallery-img]')] : [];
    const count = slides.length;
    const thumbs = [...productRoot.querySelectorAll('[data-gallery-thumb]')];
    const dots = [...productRoot.querySelectorAll('[data-gallery-dots] span')];
    const prev = productRoot.querySelector('[data-gallery-prev]');
    const next = productRoot.querySelector('[data-gallery-next]');
    if (track && count > 1) {
      const copy = (slide) => {
        const c = slide.cloneNode(true);
        c.removeAttribute('data-gallery-img');
        c.setAttribute('aria-hidden', 'true');
        c.querySelectorAll('img').forEach((img) => { img.loading = 'eager'; });
        return c;
      };
      track.insertBefore(copy(slides[count - 1]), slides[0]);
      track.appendChild(copy(slides[0]));
    }
    // Portrait photos fill the box; square/landscape ones (flat lays) are shown whole so nothing important is cut off
    track?.querySelectorAll('img').forEach((img) => {
      const fit = () => { if (img.naturalWidth && img.naturalWidth / img.naturalHeight > 0.9) img.dataset.fit = 'contain'; };
      if (img.complete) fit(); else img.addEventListener('load', fit, { once: true });
    });
    let current = 0;
    const markCurrent = (i) => {
      current = i;
      thumbs.forEach((t, n) => t.setAttribute('aria-current', String(n === i)));
      dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
    };
    // position in the track: 0 = copy of last, 1..count = real photos, count + 1 = copy of first
    const scrollToPos = (pos, smooth) => track.scrollTo({ left: pos * track.clientWidth, behavior: smooth ? 'smooth' : 'auto' });
    const goTo = (i, smooth) => {
      if (!track || !count) return;
      if (count === 1) { markCurrent(0); return; }
      const wrapped = ((i % count) + count) % count;
      // going past either end slides onto the copy, then settles onto the real photo
      const pos = i < 0 ? 0 : i >= count ? count + 1 : i + 1;
      scrollToPos(pos, smooth);
      markCurrent(wrapped);
    };
    function showImage(id) {
      const i = slides.findIndex((s) => String(s.dataset.galleryImg) === String(id));
      if (i >= 0) goTo(i, true);
    }
    if (track && count > 1) {
      let raf = 0;
      let settleTimer = 0;
      let jumping = false;
      const jump = (pos) => {
        jumping = true;
        track.style.scrollSnapType = 'none';
        scrollToPos(pos, false);
        requestAnimationFrame(() => requestAnimationFrame(() => { track.style.scrollSnapType = ''; jumping = false; }));
      };
      const settle = () => {
        const pos = Math.round(track.scrollLeft / (track.clientWidth || 1));
        if (pos === 0) jump(count);
        else if (pos === count + 1) jump(1);
      };
      track.addEventListener('scroll', () => {
        if (jumping) return;
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => {
          const pos = Math.round(track.scrollLeft / (track.clientWidth || 1));
          const i = (pos - 1 + count) % count;
          if (i !== current) markCurrent(i);
        });
        clearTimeout(settleTimer);
        settleTimer = setTimeout(settle, 140);
      }, { passive: true });
      thumbs.forEach((t) => t.addEventListener('click', () => showImage(t.dataset.galleryThumb)));
      prev?.addEventListener('click', () => goTo(current - 1, true));
      next?.addEventListener('click', () => goTo(current + 1, true));
      track.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(current - 1, true); }
        if (e.key === 'ArrowRight') { e.preventDefault(); goTo(current + 1, true); }
      });
      window.addEventListener('resize', () => scrollToPos(current + 1, false));
      const startThumb = thumbs.findIndex((t) => t.getAttribute('aria-current') === 'true');
      goTo(Math.max(0, startThumb), false);
    }
  }

  // Filter drawer
  const drawer2 = document.querySelector('[data-filter-drawer]');
  if (drawer2) {
    const overlay = document.querySelector('[data-filter-overlay]');
    const setOpen = (open) => {
      drawer2.classList.toggle('is-open', open);
      overlay.classList.toggle('is-open', open);
      document.body.style.overflow = open ? 'hidden' : '';
    };
    // Delegated on document, not bound to the button itself: live filtering replaces the
    // toolbar (and its Filter button) with fresh markup on every update, which would
    // otherwise leave the new button without its click handler until a full page reload.
    document.addEventListener('click', (e) => {
      if (e.target.closest('[data-filter-open]')) setOpen(true);
    });
    document.querySelector('[data-filter-close]').addEventListener('click', () => setOpen(false));
    // Filters already apply live as they're chosen, so "Toon resultaten" just closes the drawer.
    drawer2.addEventListener('filter:apply', () => setOpen(false));
    overlay.addEventListener('click', () => setOpen(false));
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape') setOpen(false); });

    // Swipe right to close, alongside the × button. A drag only takes over once it is
    // clearly more horizontal than vertical, so scrolling the filter list still works.
    let startX = 0;
    let startY = 0;
    let dx = 0;
    let dragging = null;
    drawer2.addEventListener('touchstart', (e) => {
      if (!drawer2.classList.contains('is-open')) return;
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
      dx = 0;
      dragging = null;
    }, { passive: true });
    drawer2.addEventListener('touchmove', (e) => {
      if (!drawer2.classList.contains('is-open')) return;
      const nx = e.touches[0].clientX - startX;
      const ny = e.touches[0].clientY - startY;
      if (dragging === null) {
        if (Math.abs(nx) < 10 && Math.abs(ny) < 10) return;
        dragging = Math.abs(nx) > Math.abs(ny) && nx > 0;
      }
      if (!dragging) return;
      dx = Math.max(0, nx);
      drawer2.style.transition = 'none';
      drawer2.style.transform = `translateX(${dx}px)`;
      e.preventDefault();
    }, { passive: false });
    drawer2.addEventListener('touchend', () => {
      if (dragging) {
        drawer2.style.transition = '';
        drawer2.style.transform = '';
        if (dx > drawer2.offsetWidth * 0.3) setOpen(false);
      }
      dragging = null;
      dx = 0;
    });
  }

  // Shoppable video reels: play when visible, sound toggle, quick add, arrows,
  // and (on mobile) a centered, endlessly swipeable carousel.
  document.querySelectorAll('[data-reels]').forEach((root) => {
    const track = root.querySelector('[data-reels-track]');
    const mobile = window.matchMedia('(max-width: 749px)');
    const GAP = 14;

    const io = 'IntersectionObserver' in window
      ? new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          const v = en.target;
          if (en.isIntersecting) { v.preload = 'auto'; v.play().catch(() => {}); } else { v.pause(); }
        });
      }, { threshold: 0.4 })
      : null;
    const watch = (scope) => scope.querySelectorAll('video').forEach((v) => { v.muted = true; if (io) io.observe(v); });
    watch(root);

    // Delegated handlers, so cloned slides work too
    root.addEventListener('click', (e) => {
      const btn = e.target.closest('[data-reel-sound]');
      if (!btn) return;
      const v = btn.closest('.reel__video').querySelector('video');
      const turnOn = v.muted;
      root.querySelectorAll('video').forEach((o) => { o.muted = true; });
      root.querySelectorAll('[data-reel-sound]').forEach((b) => { b.classList.remove('is-on'); b.setAttribute('aria-pressed', 'false'); });
      if (turnOn) { v.muted = false; btn.classList.add('is-on'); btn.setAttribute('aria-pressed', 'true'); }
    });

    root.addEventListener('submit', async (e) => {
      const form = e.target.closest('[data-reel-add]');
      if (!form) return;
      e.preventDefault();
      const btn = form.querySelector('button');
      try {
        const res = await fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: form.elements.id.value, quantity: 1 }) });
        if (!res.ok) throw new Error();
        btn.classList.add('is-done'); btn.textContent = '\u2713';
        const cart = await (await fetch('/cart.js')).json();
        document.querySelectorAll('.cart-count').forEach((c) => { c.textContent = cart.item_count; });
        if (!document.querySelector('.cart-count')) {
          const link = document.querySelector('.header__icons a[href$="/cart"]');
          if (link) link.insertAdjacentHTML('beforeend', `<span class="cart-count">${cart.item_count}</span>`);
        }
      } catch (err) { form.submit(); }
    });

    const step = () => track.querySelector('.reel').getBoundingClientRect().width + GAP;
    root.querySelector('[data-reels-prev]')?.addEventListener('click', () => track.scrollBy({ left: -step(), behavior: 'smooth' }));
    root.querySelector('[data-reels-next]')?.addEventListener('click', () => track.scrollBy({ left: step(), behavior: 'smooth' }));

    // ---- Endless loop on mobile: [copies][originals][copies] and jump by one set width ----
    let originals = [];
    let looping = false;
    let touching = false;
    let idle;

    const centerOffset = (el) => el.offsetLeft - (track.clientWidth - el.offsetWidth) / 2;
    const setWidth = () => originals.length ? originals[originals.length - 1].offsetLeft + originals[originals.length - 1].offsetWidth + GAP - originals[0].offsetLeft : 0;

    const jump = (delta) => {
      track.style.scrollSnapType = 'none';
      track.scrollLeft += delta;
      requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
    };

    const recenter = () => {
      if (!looping || touching) return;
      const W = setWidth();
      const base = centerOffset(originals[0]);
      const pos = track.scrollLeft;
      if (pos < base - W / 2) jump(W);
      else if (pos >= base + W / 2) jump(-W);
    };

    const onScroll = () => { clearTimeout(idle); idle = setTimeout(recenter, 120); };
    track.addEventListener('touchstart', () => { touching = true; }, { passive: true });
    track.addEventListener('touchend', () => { touching = false; onScroll(); }, { passive: true });
    track.addEventListener('touchcancel', () => { touching = false; }, { passive: true });

    const enableLoop = () => {
      if (looping) return;
      originals = [...track.querySelectorAll('.reel')];
      if (originals.length < 2) return;
      const copies = originals.length < 4 ? 2 : 1;
      const make = () => originals.map((el) => {
        const c = el.cloneNode(true);
        c.setAttribute('data-clone', '');
        c.setAttribute('aria-hidden', 'true');
        return c;
      });
      const before = []; const after = [];
      for (let i = 0; i < copies; i++) { before.push(...make()); after.push(...make()); }
      track.prepend(...before);
      track.append(...after);
      before.concat(after).forEach((c) => watch(c));
      looping = true;
      track.style.scrollSnapType = 'none';
      track.scrollLeft = centerOffset(originals[0]);
      requestAnimationFrame(() => { track.style.scrollSnapType = ''; });
      track.addEventListener('scroll', onScroll, { passive: true });
    };

    const disableLoop = () => {
      if (!looping) return;
      track.removeEventListener('scroll', onScroll);
      track.querySelectorAll('[data-clone]').forEach((c) => c.remove());
      looping = false;
      track.scrollLeft = 0;
    };

    const sync = () => (mobile.matches ? enableLoop() : disableLoop());
    sync();
    if (mobile.addEventListener) mobile.addEventListener('change', sync);
    else mobile.addListener(sync);
    window.addEventListener('resize', () => { if (looping) recenter(); });
  });

  // Product recommendations (loaded on demand)
  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', class extends HTMLElement {
      connectedCallback() {
        if (this.children.length || !this.dataset.url) return;
        fetch(this.dataset.url)
          .then((r) => r.text())
          .then((html) => {
            const el = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
            if (el && el.innerHTML.trim()) { this.innerHTML = el.innerHTML; this.dispatchEvent(new CustomEvent('recommendations:loaded', { bubbles: true })); }
          })
          .catch(() => {});
      }
    });
  }

  // Hero video: mount the desktop or the portrait (mobile) video, only one is ever downloaded.
  // Respects reduced motion and offers a pause/play button.
  document.querySelectorAll('[data-hero]').forEach((hero) => {
    const media = hero.querySelector('.hero__media');
    const btn = hero.querySelector('[data-hero-toggle]');
    const templates = {
      desktop: hero.querySelector('template[data-hero-video="desktop"]'),
      mobile: hero.querySelector('template[data-hero-video="mobile"]'),
    };
    if (!templates.desktop && !templates.mobile) return;

    const phone = window.matchMedia('(max-width: 749px)');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let video = null;

    const sync = () => {
      if (!btn) return;
      btn.hidden = !video;   // no video on this screen size, so no pause button either
      if (!video) return;
      btn.classList.toggle('is-paused', video.paused);
      btn.setAttribute('aria-label', video.paused ? btn.dataset.labelPlay : btn.dataset.labelPause);
    };

    const mount = () => {
      const key = phone.matches ? 'mobile' : 'desktop';
      // Phones may fall back to the desktop video; desktop never uses the (portrait) mobile video
      const tpl = key === 'mobile' ? (templates.mobile || templates.desktop) : templates.desktop;
      if (video && video.dataset.heroKey === key) return;
      const wasPaused = video ? video.paused : false;
      if (video) { video.pause(); video.remove(); video = null; }
      if (!tpl) { sync(); return; }
      video = document.importNode(tpl.content, true).querySelector('video');
      if (!video) { sync(); return; }
      video.dataset.heroKey = key;
      video.muted = true;
      media.appendChild(video);
      video.addEventListener('play', sync);
      video.addEventListener('pause', sync);
      if (reduce.matches || wasPaused) { video.removeAttribute('autoplay'); video.pause(); } else { video.play().catch(() => {}); }
      sync();
    };

    if (btn) btn.addEventListener('click', () => { if (!video) return; if (video.paused) video.play().catch(() => {}); else video.pause(); });
    mount();
    if (phone.addEventListener) phone.addEventListener('change', mount); else phone.addListener(mount);
  });

  // Hero fills the screen below the header. The height is measured ONCE (small viewport, address bar
  // expanded) and fixed in px. On phones it only re-measures when the WIDTH changes (rotation), never while
  // scrolling; on desktop it also follows window height changes (no dynamic browser bars there). Browser
  // zoom does not re-measure: the hero then scales with the rest of the page instead of staying huge.
  document.querySelectorAll('[data-hero-fill]').forEach((hero) => {
    const phone = window.matchMedia('(max-width: 749px)');
    let lastWidth = 0;
    let lastHeight = 0;
    let lastRatio = window.devicePixelRatio || 1;
    const smallViewportHeight = () => {
      const probe = document.createElement('div');
      probe.style.cssText = 'position:fixed;left:0;top:0;width:1px;height:100svh;visibility:hidden;pointer-events:none';
      document.body.appendChild(probe);
      const h = probe.offsetHeight;
      probe.remove();
      return h || window.innerHeight;
    };
    const size = (force) => {
      const w = window.innerWidth;
      const h = window.innerHeight;
      const ratio = window.devicePixelRatio || 1;
      const zoomed = ratio !== lastRatio;
      lastRatio = ratio;
      // Browser zoom (devicePixelRatio changed): keep the CSS height, so the hero scales with the page
      if (!force && zoomed) { lastWidth = w; lastHeight = h; return; }
      if (!force && w === lastWidth && (phone.matches || h === lastHeight)) return;
      lastWidth = w;
      lastHeight = h;
      const top = hero.getBoundingClientRect().top + window.scrollY;
      hero.style.setProperty('--hero-px', `${Math.max(320, Math.floor(smallViewportHeight() - top))}px`);
    };
    size(true);
    window.addEventListener('resize', () => size(false));
    window.addEventListener('orientationchange', () => setTimeout(() => size(true), 250));
    if (phone.addEventListener) phone.addEventListener('change', () => size(true));

    // The space above the hero (announcement bar + header) can still change after first paint: web fonts and
    // the logo load, and a video slows everything down. Re-measure then, but only while the page is still at
    // the top, so the value can never jump while someone is scrolling.
    const settle = () => { if (window.scrollY === 0) size(true); };
    window.addEventListener('load', settle);
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(settle);
    if ('ResizeObserver' in window) {
      const ro = new ResizeObserver(settle);
      document.querySelectorAll('.announcement, .header').forEach((el) => ro.observe(el));
    }
  });
})();
